import { relationshipSummaryModel } from '~/models';
export const getActiveAgreementIds = (summaries, clientId)=>summaries.filter((summary)=>summary.customer.id === clientId && !summary.isSample && summary.agreementStatusV2 === relationshipSummaryModel.AgreementStatus.Active).map((summary)=>summary.id);
